"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8128],{

/***/ 8128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ InterstitialsAds; }
/* harmony export */ });
/* harmony import */ var _hooks_useScriptFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1436);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


// @refresh reset
function InterstitialsAds() {
    var shouldRenderAds = (0,_hooks_useScriptFlag__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        adFlag: "google"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.googletag = window.googletag || {
            cmd: []
        };
        var interstitialSlot;
        if (shouldRenderAds) {
            googletag.cmd.push(function() {
                interstitialSlot = googletag.defineOutOfPageSlot("/22189562696/Interstitial_2023", googletag.enums.OutOfPageFormat.INTERSTITIAL);
                interstitialSlot.addService(googletag.pubads());
                if (interstitialSlot) {
                    interstitialSlot.setConfig({
                        interstitial: {
                            triggers: {
                                unhideWindow: true
                            }
                        }
                    });
                    googletag.display(interstitialSlot);
                    // Ao usar disableInitialLoad(), depois de chamar display no espaço, a solicitação de anúncio ainda precisa ser acionada chamando refresh()
                    googletag.pubads().refresh([
                        interstitialSlot
                    ]);
                }
            });
        }
    });
    return null;
}


/***/ })

}]);